import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogProps } from '../../../domain/model/common/confirmDialogProps';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrl: './create-account.component.css'
})
export class CreateAccountComponent {

  constructor(private readonly router: Router, public dialogo: MatDialog) {
}
  registerAs: string ='0';
  onSelectCard(registerAs: string) {
this.registerAs = registerAs;
this.selectUserType.setValue({userType : registerAs});
  }
  radioChange(event: any) {
     this.registerAs = event.value;
   }
   selectUserType = new FormGroup({
    userType: new FormControl('', [
      Validators.required,
     
    ])
  });

  redirectTo() {
    if(this.registerAs == "1"){
      this.router.navigate(['register/registerAsOwner']);
    }
    if(this.registerAs == "2"){
      this.router.navigate(['register/registerAsPropertyManagmentCompany']);
    }
    if(this.registerAs == "3"){
      this.router.navigate(['register/registerAsHotelMotel']);
    }
  }

  onCancelClick() {

    let messageInfo : ConfirmDialogProps = {
      title: 'Are you sure you want to cancel the sign up process?',
      message: 'All data provided up to this point will be lost. If you cancel now, you will need to start the sign-in process from the beginning.',
      backComponent: '/login'
    }
    this.dialogo
    .open(ConfirmDialogComponent, {
      data: messageInfo,
   
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {
      if (confirmado) {
       // alert("¡A mí también!");
      } else {
       // alert("Deberías probarlo, a mí me gusta :)");
      }
    });
  }
}
